import React from "react";
import "../components/terms.css";
const Terms = () => {
  return (
    <div className="terms">
      <h1>Terms of Use</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin et congue
        dui. Duis pretium ut turpis eu posuere. Phasellus ultrices lorem sed
        convallis ultricies. Sed vel turpis augue. Integer a accumsan ex.
        Vivamus congue orci finibus vehicula blandit. Vivamus suscipit tortor
        lacus, ut venenatis turpis feugiat a. Sed sed lacinia mauris. Sed in
        diam ut urna rutrum condimentum. Etiam non tempus velit. Vivamus sed
        iaculis felis. Phasellus leo mauris, malesuada sed vulputate vitae,
        commodo in ante. Praesent facilisis semper risus, sit amet gravida dui
        venenatis at. Proin vulputate viverra est. Integer urna sapien, viverra
        convallis vulputate tempor, semper non nisi.
      </p>
      <p>
        Morbi sodales ultricies magna sit amet sagittis. Aliquam sapien est,
        auctor in lobortis quis, sollicitudin sit amet libero. Integer pretium
        sodales augue ac ullamcorper. Sed volutpat ligula in quam dapibus, et
        ultrices augue congue. Nullam finibus sapien nec mi gravida porta.
        Mauris consequat, tellus eget eleifend condimentum, libero mi lobortis
        nulla, eu porttitor felis erat in nunc. In hac habitasse platea
        dictumst. In hendrerit magna vitae odio posuere vestibulum. Ut id
        imperdiet orci, a suscipit elit.
      </p>
      <p>
        Duis massa arcu, tincidunt sit amet libero at, convallis sodales augue.
        Donec tincidunt arcu neque, vitae maximus est commodo at. Duis vehicula
        euismod diam eu efficitur. Cras gravida arcu libero, id feugiat nunc
        feugiat at. Pellentesque habitant morbi tristique senectus et netus et
        malesuada fames ac turpis egestas. Class aptent taciti sociosqu ad
        litora torquent per conubia nostra, per inceptos himenaeos. Phasellus
        faucibus porttitor urna id lacinia.
      </p>
      <p>
        Aenean pulvinar eros ut ullamcorper viverra. Donec porttitor dolor nec
        odio lacinia, id convallis purus laoreet. Nunc sagittis mauris odio, a
        egestas dolor aliquet et. Aliquam tristique lacus mauris, eget euismod
        justo imperdiet vitae. Suspendisse potenti. Integer tincidunt blandit
        nibh, eget imperdiet magna. Integer auctor, augue sed maximus maximus,
        leo enim rhoncus enim, at facilisis est dolor vel neque. Aliquam erat
        volutpat. Nam porta nisl finibus neque gravida, at convallis tellus
        tristique.
      </p>
      <p>
        In placerat lacinia odio, ac scelerisque odio tincidunt ac. Interdum et
        malesuada fames ac ante ipsum primis in faucibus. Integer accumsan in
        quam eu lobortis. In ex metus, imperdiet et nunc interdum, vestibulum
        suscipit mi. Donec vulputate ex elementum, hendrerit tortor non,
        volutpat quam. Fusce id pulvinar est, quis pharetra turpis. Curabitur
        imperdiet, orci vel lacinia tempus, nisl elit ornare ligula, vel aliquet
        odio nulla ut elit. Aliquam dapibus pulvinar diam, non rhoncus mi.
      </p>
      <p>
        In dapibus a odio vel ultricies. Maecenas placerat justo vitae purus
        porta finibus. Fusce non congue diam, non pellentesque nisi. Nullam
        venenatis aliquet nunc, non hendrerit turpis. Sed lobortis justo a odio
        semper, molestie auctor nisl feugiat. Pellentesque in arcu id erat
        finibus bibendum in eget leo. Curabitur vulputate, nisl non viverra
        facilisis, felis quam accumsan augue, ac venenatis sem ante a ligula.
        Nulla a venenatis elit, sit amet porta sapien. Maecenas non arcu ut nisl
        gravida scelerisque in ut tellus. Fusce dolor sem, facilisis in sem id,
        fringilla dignissim neque. Sed sed nisi vel augue tristique consequat
        vitae sit amet ipsum. Cras aliquam ligula ut porttitor mollis. Lorem
        ipsum dolor sit amet, consectetur adipiscing elit. Duis id faucibus
        arcu.
      </p>
      <p>
        Cras id ullamcorper nisl. Sed ut vulputate ipsum. Praesent faucibus, dui
        id egestas vulputate, purus sem porttitor orci, sed bibendum erat lectus
        sed dui. Integer consequat est quis metus cursus, quis pharetra odio
        euismod. Suspendisse hendrerit massa a sem vestibulum, sit amet faucibus
        massa dictum. Mauris finibus libero enim, quis faucibus nisl cursus
        sollicitudin. In vestibulum ultricies erat a lobortis. Mauris ultricies
        justo neque, id vulputate velit fringilla sit amet.
      </p>
      <p>
        Proin dapibus pretium lorem eget blandit. Vivamus porttitor, magna vitae
        euismod sodales, metus velit aliquet leo, et egestas ipsum lectus
        imperdiet metus. Quisque semper, elit et euismod eleifend, nunc erat
        bibendum metus, ac pretium nisi lorem id est. Aliquam a elementum ipsum.
        Suspendisse magna ipsum, bibendum at nisl at, condimentum hendrerit
        nunc. Maecenas a nisl a neque dignissim porttitor. Etiam mollis, magna
        quis interdum cursus, urna lectus varius metus, vel sagittis mi quam id
        elit. Donec lacinia facilisis est id ultricies.
      </p>
      <p>
        Vestibulum facilisis nulla eu velit lobortis malesuada. Phasellus
        gravida augue augue, vitae bibendum arcu dapibus et. Nullam in odio
        volutpat, interdum elit a, semper quam. Pellentesque ultricies odio eu
        augue consectetur porttitor. Donec at metus ac nulla placerat rutrum
        eget ac ante. Donec condimentum magna a quam iaculis, sit amet
        vestibulum neque viverra. Duis eget magna at nunc dignissim sagittis ut
        quis massa. Morbi aliquet lectus ligula. Aliquam ipsum tortor, luctus at
        tempor a, tristique semper nibh. Integer ultricies molestie tristique.
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vitae
        tortor ut enim mattis ultrices.
      </p>
      <p>
        Mauris tincidunt justo ac erat dignissim mollis. Proin in pretium eros,
        a volutpat neque. Orci varius natoque penatibus et magnis dis parturient
        montes, nascetur ridiculus mus. Lorem ipsum dolor sit amet, consectetur
        adipiscing elit. Vestibulum vehicula pretium massa, non vehicula augue
        tristique non. Cras finibus sit amet ligula eu lobortis. Cras suscipit
        ultrices ante dictum molestie.
      </p>
    </div>
  );
};

export default Terms;
